import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CookieService } from 'src/app/customServices/cookie.service';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';

@Component({
    selector: 'app-customer-id',
    templateUrl: './customer-id.component.html',
    styleUrls: ['./customer-id.component.scss'],
    standalone: false
})
export class CustomerIdComponent {
  selectedOption: any;
  @Input('show') showContent: boolean;
  @Output() childValueChange = new EventEmitter<any>();
  @Input('arrData') options: any[];
  @Input('current') isCustomerIdCookieSet: boolean;
  constructor(private cookieService: CookieService, private customerIdService:CustomerIdService) { }
  ngOnChanges() {
    this.isCustomerIdCookieSet = this.cookieService.isCookieSet('customerIdNA');
    if (this.isCustomerIdCookieSet) {
      const custId = this.cookieService.getCookieValue('customerIdNA');
      if (this.options !== undefined) {
        this.options.find((x) => {
          if (x.uid === custId) {
            this.selectedOption = x.uid;
            this.customerIdService.isOrderBlocked$.next(x.orderBlocked);
          }
        });
      }
    } else {
      if (this.options !== undefined) {
        this.options.find((x) => {
          if (x.selected) {
            this.selectedOption = x.uid;
          }
        });
      }
    }
  }

  setNewCustomerId() {
    const event = this.options.filter((res) => res.uid === this.selectedOption)[0];
    this.childValueChange.emit(event);
  }
}
